import axios from "axios";
import React, { Component } from 'react'

const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");


class twostarreview extends Component {
  state = {
    reviews: []
  }



  componentDidMount() {

    axios.get(`https://shoppee-clone.herokuapp.com/tworeview/${id}/`)
      .then(res => {
        console.log(res.data)
        const reviews = res.data;
        this.setState({ reviews });

      })
      .catch((error) => {
        console.log(error); //View in Browser's Developer Tools

      })
  }



  render() {
    return (
      <div>
        {this.state.reviews.map(post =>
          <div class="card">
            <div className="reviewcard  p-3 mb-5 shadow-sm rounded "><span className="h4">{post.username}</span>
              <p className="email h6 text-secondary">{post.email}</p>
              <p className="rating h5">{post.rating}</p>
              <p className="review h6">{post.review}</p>
            </div></div>)}

      </div>

    )
  }
}

export default twostarreview